<template>
  <div class="flex relative" :class="{ 'w-full': fullwidth }">
    <div
      class="flex relative"
      :class="{
        'opacity-100': !disabled,
        'opacity-50': disabled,
        'w-full': fullwidth,
      }"
      @click="onClick"
    >
      <div
        class="tab-selector py-8 rounded-regular text-small border flex items-center justify-center transition-all duration-200 relative z-10"
        :class="{
          'bg-white border-blue-50 text-standard': selected && !danger,
          'border-secondary hover:bg-white hover:border-blue-50 bg-picker text-black-75':
            !selected && !danger,
          'bg-white border-warning text-warning': danger,
          'line-through': disabled,
          'cursor-pointer select-none': !disabled,
          'w-full': fullwidth,
          'px-24': !narrow,
          'px-12': narrow,
        }"
      >
        {{ text }}
        <fa
          v-if="monitorStock"
          class="text-sm mr-6 absolute top-0 right-0 mt-2"
          :icon="['fal', 'envelope']"
        />
      </div>
      <div
        v-if="selected || danger"
        class="absolute inset-selected-border rounded-regular"
        :class="{
          'bg-orange-25': danger,
          'bg-secondary': !danger,
        }"
      />
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
export default defineComponent({
  props: {
    text: {
      type: String,
      required: false,
      default: '',
    },
    selected: {
      type: Boolean,
      required: false,
      default: false,
    },
    danger: {
      type: Boolean,
      required: false,
      default: false,
    },
    disabled: {
      type: Boolean,
      required: false,
      default: false,
    },
    fullwidth: {
      type: Boolean,
      required: false,
      default: false,
    },
    narrow: {
      type: Boolean,
      required: false,
      default: false,
    },
    monitorStock: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  methods: {
    onClick() {
      if (!this.disabled) {
        this.$emit('click');
      }
    },
  },
});
</script>
